/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import { doLog, updateObject } from "../../shared/utility";

import * as actions from "../../store/actions/index";
import Grid from "@material-ui/core/Grid";
import Form from "../../components/UI/Form/Form";

const mappedSelectPropFields = [];

const mappedTextPropFields = ["AGENCYCODE", "TEXTLOCATION", "CUSTOMTEXT"];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

// const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
// const quote = '"';
// const singleQuote = "'";

class ManageCustomText extends Form {
  state = {
    searching: false,
    editMode: true,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    keyFieldValue: null,
    sectionName: "ManageCustomText",
    //
    customTextIndex: -1,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    AGENCYCODE: {
      inputType: "text",
      value: "",
      default: "",
      label: "Agency Code",
      maxSize: 20,
      validation: { required: true },
      upperOnly: true,
      keyField: true,
    },
    TEXTLOCATION: {
      inputType: "text",
      value: "",
      default: "",
      label: "Location of Text",
      maxSize: 20,
      disabled: true,
      validation: { required: false },
    },
    CUSTOMTEXT: {
      inputType: "text",
      value: "",
      default: "",
      multiline: true,
      rows: 4,
      label: "Custom Text",
    },
  };

  componentDidMount() {
    if (doLog()) console.log("[ManageCustomText] componentDidMount state:", this.state);
    if (doLog()) console.log("[ManageCustomText] componentDidMount props:", this.props);
    this.copyFieldValuesToState();
  }

  componentDidUpdate() {
    if (doLog()) console.log("[ManageCustomText] componentDidUpdate state:", this.state);
    if (doLog()) console.log("[ManageCustomText] componentDidUpdate props:", this.props);
  }

  copyFieldValuesToState() {
    if (doLog()) console.log(
      "[ManageCustomText]copyFieldValuesToState item:",
      this.props.item
    );
    if (this.props.item !== null) {
      const item = this.props.item;
      for (let field in this.state.mappedTextPropFields) {
        const fieldName = this.state.mappedTextPropFields[field];
        if (doLog()) console.log(
          "[ManageCustomText]copyFieldValuesToState text field:",
          fieldName
        );
        const newValue = item[fieldName];
        if (doLog()) console.log(
          "[ManageCustomText]copyFieldValuesToState text newValue:",
          newValue
        );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: item[fieldName],
          }),
        });
        if (this.state[fieldName].keyField === true) {
          this.setState({ keyFieldValue: item[fieldName] });
        }
      }

      for (let field in this.state.mappedSelectPropFields) {
        const fieldName = this.state.mappedSelectPropFields[field];
        if (doLog()) console.log(
          "[ManageCustomText]copyFieldValuesToState select field:",
          fieldName
        );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: item[fieldName],
          }),
        });
      }

      const fields = {
        AGENCYCODE: updateObject(this.state.AGENCYCODE, {
          value: item.AGENCYCODE,
        }),
        TEXTLOCATION: updateObject(this.state.TEXTLOCATION, {
          value: item.TEXTLOCATION,
        }),
        CUSTOMTEXT: updateObject(this.state.CUSTOMTEXT, {
          value: item.CUSTOMTEXT,
        }),
      };

      this.setState({ customTextIndex: this.props.index });
      if (doLog()) console.log(
        "[ManageCustomText] componentDidMount customTextIndex:",
        this.props.index
      );

      this.props.onNewControl(this.props.index, fields);
    }
  }

  render() {
    return (
      <Fragment>
        <Grid item xs={3}>
          {this.getFormField("TEXTLOCATION", false, true)}
        </Grid>
        <Grid item xs={9}>
          {this.getFormField("CUSTOMTEXT", false, true)}
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[ManageAgency] mapStateToProps state:", state);
  return {
    customTextArray: state.trans.customTextArray,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetCustomTextArray: (customTextArray) =>
      dispatch(actions.setCustomTextArray(customTextArray)),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(ManageCustomText)
// );
export default connect(mapStateToProps, mapDispatchToProps)(ManageCustomText);
